<template>
  <div class="home">
    <div class="home-main">
      <div class="home-main-center">
        <div class="title">今日新注册用户（人）</div>
        <div class="num">{{ staticData.todayUser || 0 }}</div>
        <div class="home-main-center-infor">
          <div class="home-main-center-infor-item">
            昨日新增：{{ staticData.preDayUser || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            本月新增：{{ staticData.currMonthUser || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            累计新增：{{ staticData.totalUser || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            上月新增：{{ staticData.preMonthUser || 0 }}
          </div>
        </div>
      </div>
      <div class="home-main-center">
        <div class="title">今日访客数（人）</div>
        <div class="num">{{ staticData.todayUv || 0 }}</div>
        <div class="home-main-center-infor">
          <div class="home-main-center-infor-item">
            昨日访客：{{ staticData.preDayUv || 0 }}
          </div>

          <div class="home-main-center-infor-item">
            本月访客：{{ staticData.currMonthUv || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            累计访客：{{ staticData.totalUv || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            上月访客：{{ staticData.preMonthUv || 0 }}
          </div>
        </div>
      </div>
      <div class="home-main-center">
        <div class="title">今日订单数（单）</div>
        <div class="num">{{ staticData.todayOrder || 0 }}</div>
        <div class="home-main-center-infor">
          <div class="home-main-center-infor-item">
            昨日订单：{{ staticData.preDayOrder || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            本月订单：{{ staticData.currMonthOrder || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            累计订单：{{ staticData.totalOrder || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            上月订单：{{ staticData.preMonthOrder || 0 }}
          </div>
        </div>
      </div>
      <div class="home-main-center">
        <div class="title">今日交易额（元）</div>
        <div class="num">￥{{ staticData.todaySalesAmount || 0 }}</div>
        <div class="home-main-center-infor">
          <div class="home-main-center-infor-item">
            昨日：￥{{ staticData.preDaySalesAmount || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            本月：￥{{ staticData.currMonthSalesAmount || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            累计：￥{{ staticData.totalSalesAmount || 0 }}
          </div>
          <div class="home-main-center-infor-item">
            上月：￥{{ staticData.preMonthSalesAmount || 0 }}
          </div>
        </div>
      </div>

    </div>
    <div class="echartsCenter" style="width: 100%">
      <p class="echartsLeftBtn" @click="rightEcharts()">
        <img src="http://fs-cdn.jouma.cn/topup/report/img/left.png"></p>
      <p class="echartsRightBtn" v-if="search.pageNo>1" @click="leftEcharts()"><img
          src="http://fs-cdn.jouma.cn/topup/report/img/right.png"></p>
      <div id="main" :style="{width: '100%', height: chartHeight}"></div>
    </div>
    <div class="home-table">
      <div class="title">数据报表 <p><span @click="searchData(1)" :class="search.type==1?'on':''">日报</span>/<span
          @click="searchData(2)" :class="search.type==2?'on':''">月报</span></p></div>

      <!-- PC端表格展示 -->
      <Table
          v-if="!isMobile"
          :columns="diyData.columns"
          :data="tableData"
      >
        <template slot="footer">
          <Page
              :total="total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>

      <!-- 移动端竖向展示 -->
      <div v-else class="mobile-table">
        <div v-for="(item, index) in tableData" :key="index" class="mobile-table-item">
          <div class="mobile-table-row" v-for="column in diyData.columns" :key="column.key">
            <div class="mobile-table-label">{{ column.title }}：</div>
            <div class="mobile-table-value">{{ item[column.key] }}</div>
          </div>
        </div>

        <div class="mobile-pagination">
          <Page
              :total="total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { kpiBus, staticData, staticList } from '@/api/index.js'

export default {
  name: 'home',
  data () {
    return {
      staticData: {
        currMonthOrder: 0,
        currMonthSalesAmount: 0,
        currMonthUser: 0,
        preDayOrder: 0,
        preDaySalesAmount: 0,
        preDayUser: 0,
        preMonthOrder: 0,
        preMonthSalesAmount: 0,
        preMonthUser: 0,
        todayOrder: 0,
        todaySalesAmount: 0,
        todayUser: 0,
        totalOrder: 0,
        totalSalesAmount: 0,
        totalUser: 0
      },
      diyData: {
        columns: [
          {
            title: '日期',
            key: 'date'
          },
          {
            title: '用户新增',
            key: 'userNumbers'
          },
          {
            title: '访问人数',
            key: 'uv'
          },
          {
            title: '订单数',
            key: 'orderNumbers'
          },
          {
            title: '交易额',
            key: 'salesAmount'
          },
          {
            title: '优惠额',
            key: 'discountAmount'
          },
          {
            title: '退款金额',
            key: 'refundAmount'
          }
        ]
      },
      isRight: true,
      page: 1,
      tableData: [],
      total: 0,
      search: {
        type: 1,
        pageNo: 1,
        pageSize: 10
      },
      chartHeight: '440px',
      isMobile: false
    }
  },
  methods: {
    getstaticList () {
      var that = this
      var param = {
        timestamp: new Date().getTime(),
        pageNo: this.search.pageNo,
        pageSize: 30
      }
      staticList(param).then(res => {
        that.loading = false
        if (res.code == 200) {
          var xAxisTime = []// 时间
          var duration = [] // 订单数
          var distance = [] // 营业额
          var userNumbers = [] // 用户新增
          var durationAll = 0// 订单数总数
          var distanceAll = 0// 营业额总数
          res.data.forEach(element => {
            xAxisTime.push(element.date)
            duration.push(element.orderNumbers)
            distance.push(element.salesAmount)
            userNumbers.push(element.userNumbers)
            durationAll += Number(element.orderNumbers)
            distanceAll += Number(element.salesAmount)
          })

          if (res.data.length > 0) {
            that.getmyChart(xAxisTime.reverse(), duration.reverse(), distance.reverse(), userNumbers.reverse(), durationAll, distanceAll)
            console.info('totalSize:' + res.data.length)
            if (res.data.length >= 30) {
              that.isRight = true
            } else {
              that.isRight = false
            }
          } else {
            this.search.page = this.search.page - 1
          }
        }
      })
    },
    getmyChart (xAxisTime, duration, distance, userNumbers, durationAll, distanceAll) {
      var that = this
      // var distanceTxt='营业额 / 总计：'+distanceAll.toFixed(2)+'元'
      // var durationTxt='单数 / 总计：'+durationAll+'单'
      // var legendData=[{name:distanceTxt,icon: 'roundRect'},{name:durationTxt,icon: 'circle'}]
      var myChart = this.$echarts.init(document.getElementById('main'))
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: '交易统计'
        },
        tooltip: {
          trigger: 'axis',
          // formatter: function(params) {
          //     let str = params[0].axisValue+'<br>';
          //     params.forEach((item, idx) => {
          //         var title=that.getStr(item.seriesName,'/')
          //         var unit=''
          //         if(title=='营业额 '){
          //             unit="元"
          //         }else if(title=='单数 '){
          //             unit="单"
          //         }
          //         str+=item.marker+''+title+'：'+item.data+unit+'<br>'
          //         // str+=`${item.marker}${title}: ${item.data}`+'<br>'
          //     })
          //     return str
          // },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          width: '100%'
        },
        legend: {
          data: ['交易额', '订单数', '用户数'],
          right: '0%'
        },
        xAxis: {
          type: 'category',
          data: xAxisTime
        },
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '交易额',
            type: 'line',
            data: distance,
            symbolSize: 8,
            lineStyle: {
              color: '#1890FF',
              width: 1.5
            },
            itemStyle: {
              color: '#1890FF'
            }

          },
          {
            name: '订单数',
            type: 'line',
            data: duration,
            symbolSize: 8,
            lineStyle: {
              color: '#2FC25B',
              width: 1.5
            },
            itemStyle: {
              color: '#2FC25B'
            }
          },
          {
            name: '用户数',
            type: 'line',
            data: userNumbers,
            symbolSize: 8,
            lineStyle: {
              color: '#e42a77',
              width: 1.5
            },
            itemStyle: {
              color: '#e42a77'
            }
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
      console.log(myChart)
    },
    leftEcharts () {
      if (this.search.pageNo > 1) {
        this.search.pageNo = this.search.pageNo - 1
        this.loading = true
        this.getstaticList()
      }
    },
    rightEcharts () {
      if (this.isRight) {
        this.search.pageNo = this.search.pageNo + 1
        this.loading = true
        this.getstaticList()
      }
    },
    getStaticData () {
      staticData().then(res => {
        console.log(res)
        const { data } = res
        this.staticData = data
      })
    },
    // 分页
    pageChange (e) {
      this.search.pageNo = e
      this.getkpiBus()
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getkpiBus()
    },
    searchData (i) {
      this.search.type = i
      this.search.pageNo = 1
      this.getkpiBus()
    },
    // 日报月报
    getkpiBus () {
      var that = this
      var param = {
        token: localStorage.getItem('token'),
        ...that.search
      }
      kpiBus(param).then(res => {
        that.tableData = res.data.list
        that.total = res.data.totalCount
      })
    },
    handleResize () {
      // 根据屏幕宽度调整图表高度
      const screenWidth = document.body.clientWidth
      this.isMobile = screenWidth < 768

      if (screenWidth < 480) {
        this.chartHeight = '200px'
      } else if (screenWidth < 768) {
        this.chartHeight = '300px'
      } else {
        this.chartHeight = '440px'
      }
    }
  },
  mounted () {
    this.getStaticData()
    this.getstaticList()
    this.getkpiBus()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="less">
.home {
  width: 100%;

  .home-main {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .home-main-center {
      width: 260px;
      height: 120px;
      opacity: 1;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(67, 207, 124, 1);
      padding: 10px 20px;
      box-sizing: border-box;
      margin-right: 20px;
      margin-bottom: 20px;

      .title {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 20.27px;
        color: rgba(128, 128, 128, 1);
        text-align: left;
        margin-bottom: 5px;
      }

      .num {
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 28.96px;
        color: rgba(0, 0, 0, 1);
        text-align: left;
        margin-bottom: 5px;
      }

      .home-main-center-infor {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .home-main-center-infor-item {
          width: 50%;
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 17.38px;
          color: rgba(56, 56, 56, 1);
          text-align: left;
          margin-bottom: 5px;
        }

        .home-main-center-infor-item:nth-child(2n) {
          text-align: right;
        }
      }
    }
  }

  .echartsCenter {
    width: 100%;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    margin: 20px 0;
  }

  .echartsCenter:hover .echartsLeftBtn, .echartsCenter:hover .echartsRightBtn {
    display: block;
  }

  .home-table {
    width: 100%;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    margin: 20px 0;

    .title {
      width: 100%;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 20.27px;
      color: rgba(56, 56, 56, 1);
      margin-bottom: 10px;
      display: flex;
      align-content: center;
      align-items: center;

      p {
        margin-left: 40px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 20.27px;
        color: rgba(56, 56, 56, 1);

        span {
          cursor: pointer;
          margin: 0px 5px;
        }

        span.on {
          color: 000;
          font-size: 16px;
          font-weight: 700;
        }
      }
    }
  }
}

.echartsLeftBtn {
  position: absolute;
  top: 50%;
  left: 5%;
  padding: 25px 8px;
  box-sizing: border-box;
  transform: translate(0%, -50%);
  z-index: 999;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  cursor: pointer;
  display: none;
}

.echartsRightBtn {
  position: absolute;
  top: 50%;
  right: 5%;
  padding: 25px 8px;
  box-sizing: border-box;
  transform: translate(0%, -50%);
  z-index: 999;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  cursor: pointer;
  display: none;
}

.echartsLeftBtn img, .echartsRightBtn img {
  width: 10px;
}

.echartsLeftBtn:hover, .echartsRightBtn:hover {
  background: rgba(0, 0, 0, 0.3);
}

// 移动端适配
@media screen and (max-width: 768px) {
  .home {
    .home-main {
      flex-direction: column;
      align-items: stretch;

      .home-main-center {
        width: 100%;
        height: auto;
        margin-right: 0;
        margin-bottom: 10px;
        padding: 8px 15px;

        .title {
          font-size: 12px;
          line-height: 18px;
          margin-bottom: 3px;
        }

        .num {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 3px;
        }

        .home-main-center-infor {
          .home-main-center-infor-item {
            font-size: 10px;
            line-height: 14px;
            margin-bottom: 3px;
          }
        }
      }
    }

    .home-table {
      .title {
        font-size: 12px;
        line-height: 18px;

        p {
          font-size: 12px;
          line-height: 18px;
          margin-left: 20px;

          span {
            font-size: 12px;
          }

          span.on {
            font-size: 14px;
          }
        }
      }
    }
  }

  .echartsLeftBtn, .echartsRightBtn {
    padding: 15px 5px;

    img {
      width: 8px;
    }
  }
}

@media screen and (max-width: 480px) {
  .home {
    .home-main {
      .home-main-center {
        padding: 6px 10px;

        .title {
          font-size: 11px;
          line-height: 16px;
        }

        .num {
          font-size: 14px;
          line-height: 20px;
        }

        .home-main-center-infor {
          .home-main-center-infor-item {
            font-size: 9px;
            line-height: 13px;
          }
        }
      }
    }

    .home-table {
      .title {
        font-size: 11px;
        line-height: 16px;

        p {
          font-size: 11px;
          line-height: 16px;
          margin-left: 15px;

          span {
            font-size: 11px;
          }

          span.on {
            font-size: 13px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 769px) {
  .home-main-center:nth-child(2n) {
    margin-right: 0;
  }
}

// 移动端表格样式
.mobile-table {
  width: 100%;

  .mobile-table-item {
    border: 1px solid #dcdee2;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 10px;
    background: #fff;
  }

  .mobile-table-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .mobile-table-label {
    font-weight: bold;
    width: 30%;
    color: #515a6e;
  }

  .mobile-table-value {
    width: 70%;
    color: #666;
  }

  .mobile-pagination {
    margin-top: 20px;

    /deep/ .ivu-page-options {
      display: none;
    }
  }
}
</style>
